<app-page-data-panel
  title="Learning"
  subtitle="Assigned courses and training still relevant to your role."
  [resultText]="assignments.length + ' assignments'">
  @if (assignments.length) {
    <p-table [value]="assignments" responsiveLayout="stack" breakpoint="768px">
      <ng-template pTemplate="header">
        <tr>
          <th>Course</th>
          <th>Status</th>
          <th>Assigned</th>
          <th>Due</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-assignment>
        <tr>
          <td><span class="p-column-title">Course</span>{{ assignment.courseName || assignment.courseCode }}</td>
          <td><span class="p-column-title">Status</span><p-tag [value]="label(assignment.assignmentStatus)" [severity]="statusSeverity(assignment.assignmentStatus)"></p-tag></td>
          <td><span class="p-column-title">Assigned</span>{{ assignment.assignedAt | date:'mediumDate' }}</td>
          <td><span class="p-column-title">Due</span>{{ assignment.dueDate | date:'mediumDate' }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="empty-state">No learning assignments available.</p>
  }
</app-page-data-panel>
